import { BaseController } from '../../../../../../../common/base/controller';

import { MODEL_FIELDS } from '../../createRequest.model';

export class BankNumbersController extends BaseController {
  constructor($scope, controllerService) {
    'ngInject';
    super({
      $scope,
      controllerService,
    });
  }

  inputMessagesFor(field) {
    return {
      required: `transferring.confirmWarrant.form.error.required.${field}`,
      iban: `receiving.createRequest.form.error.iban.${field}`,
      type: `receiving.createRequest.form.error.type.${field}`,
    };
  }

  getLabelFor(field) {
    return `receiving.createRequest.form.${field}`;
  }

  $onInit() {
    this.MODEL_FIELDS = MODEL_FIELDS;

    this.inputOptions = { type: 'text', validate: 'iban' };
    this.oldIbanMessages = this.inputMessagesFor(this.MODEL_FIELDS.oldIban);
    this.newIbanMessages = this.inputMessagesFor(this.MODEL_FIELDS.newIban);
  }
}
